<template>
  <alert
    v-if="showAlert"
    :cols="12"
    class="mt-4 mx-3 mb-0 w-100"
  >
    You can only have up to {{ maxFacilities }} facilities. No additional facilities can be added.
  </alert>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    showAlert: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters('facilities', ['maxFacilities']),
  },

  methods: {
    // Too many facilities in go list
    maxFacilitiesError() {
      return this.selectedFacilitiesLength - this.maxFacilities
    },
  },
};
</script>
